import {
  musicNavigationData,
  sportsNavigationData,
  ticketsNavigationData,
  citiesNavigationData,
} from '@/assets'
import { NavigationMenuData } from './NavigationMenu.types'

export const navigationMenuClasses = {
  hamburgerMenuIcon: 'hamburger-menu-icon',
}

export const NAVIGATION_LINK_NAME = {
  SPORTS: 'Sports',
  MUSIC: 'Music',
  TICKETS: 'Tickets',
  PARTNERS: 'Partners',
  CITIES: 'Cities',
} as const

export type NavigationLinkName = (typeof NAVIGATION_LINK_NAME)[keyof typeof NAVIGATION_LINK_NAME]

export const navigationItems = [
  { label: NAVIGATION_LINK_NAME.SPORTS, hasDropdown: true },
  { label: NAVIGATION_LINK_NAME.MUSIC, hasDropdown: true },
  { label: NAVIGATION_LINK_NAME.CITIES, hasDropdown: true },
  { label: NAVIGATION_LINK_NAME.TICKETS, hasDropdown: true },
  // { label: NAVIGATION_LINK_NAME.PARTNERS, hasDropdown: true },
] as const

export const NavigationData: Record<NavigationLinkName, NavigationMenuData[]> = {
  [NAVIGATION_LINK_NAME.SPORTS]: sportsNavigationData,
  [NAVIGATION_LINK_NAME.MUSIC]: musicNavigationData,
  [NAVIGATION_LINK_NAME.TICKETS]: ticketsNavigationData,
  [NAVIGATION_LINK_NAME.PARTNERS]: ticketsNavigationData, // Placeholder, not used
  [NAVIGATION_LINK_NAME.CITIES]: citiesNavigationData,
}
